import { useMsal, AuthenticatedTemplate, MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { loginRequest } from '../../authConfig';
import { PageLayout2 } from '../../Components/PageLayout/PageLayout2';
import HommeDashboard from './HomeDashboard';

const HomeContent = () => {
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();

    return (
        <PageLayout2 title="Home">
                {/* <DashboardGrid /> */}
                <HommeDashboard />
        </PageLayout2>
    );
};

export const Home = () => {
    return (
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest}>
            <HomeContent />
        </MsalAuthenticationTemplate>
    )
}